import { FC } from 'react';
import { Col, Row, Statistic } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import {
    useReportData,
    useReportQuery,
} from '@/shared/components/modals/ResourceActionModals/EditReportComponentModal/helpers/hook';
import { ReportComponent } from '@/types';

interface MultiStatisticProps {
    component: ReportComponent;
}

const MultiStatistic: FC<MultiStatisticProps> = ({ component }): JSX.Element => {
    const { token } = useAntDesignTheme();
    const query = useReportQuery(component);
    const { data } = useReportData(component);
    const metrics = query.metrics.slice(0, 8);
    const values = data.rows[0] ?? {};

    return (
        <Row
            align='middle'
            gutter={[16, 16]}
            style={{ height: '100%', margin: 0, overflow: 'auto', padding: '1rem', width: '100%' }}
        >
            {metrics.map((metric) => {
                const numericValue = Number(values[metric.field] ?? 0);

                return (
                    <Col key={metric.field} xs={24} sm={12} lg={8}>
                        <Statistic
                            title={metric.label ?? metric.field}
                            value={Number.isFinite(numericValue) ? numericValue : 0}
                        />
                    </Col>
                );
            })}
            {!metrics.length && (
                <Col span={24} style={{ textAlign: 'center' }}>
                    <small style={{ color: token.colorTextTertiary }}>
                        Select metrics to populate this statistic group.
                    </small>
                </Col>
            )}
        </Row>
    );
};

export default MultiStatistic;
